import { render, staticRenderFns } from "./OverviewComparisonContent.vue?vue&type=template&id=010b27e5"
import script from "./OverviewComparisonContent.vue?vue&type=script&lang=js"
export * from "./OverviewComparisonContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports